/**
 * Navbar narrow functionality
 * Adds tooltips to narrow sidebar navigation links
 */

export const initNavbarNarrow = () => {
  const narrowNavbar = document.querySelector('.navbar-narrow')
  
  if (!narrowNavbar) {
    return
  }

  // Initialize tooltips for narrow sidebar nav links
  const navLinks = narrowNavbar.querySelectorAll('.nav-link')
  
  navLinks.forEach(link => {
    const titleElement = link.querySelector('.nav-link-title')
    
    if (titleElement) {
      const title = titleElement.textContent.trim()
      
      if (title && !link.hasAttribute('title')) {
        link.setAttribute('title', title)
        link.setAttribute('data-bs-toggle', 'tooltip')
        link.setAttribute('data-bs-placement', 'right')
        link.setAttribute('data-bs-container', 'body')
      }
    }
  })

  // Initialize Bootstrap tooltips
  if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip) {
    const tooltipTriggerList = narrowNavbar.querySelectorAll('[data-bs-toggle="tooltip"]')
    
    tooltipTriggerList.forEach(tooltipTriggerEl => {
      new bootstrap.Tooltip(tooltipTriggerEl, {
        boundary: 'viewport',
        customClass: 'navbar-narrow-tooltip'
      })
    })
  }

  // Handle dropdown positioning for narrow sidebar
  const dropdowns = narrowNavbar.querySelectorAll('.dropdown')
  
  dropdowns.forEach(dropdown => {
    const dropdownMenu = dropdown.querySelector('.dropdown-menu')
    
    if (dropdownMenu) {
      dropdown.addEventListener('shown.bs.dropdown', () => {
        const rect = dropdown.getBoundingClientRect()
        dropdownMenu.style.position = 'fixed'
        dropdownMenu.style.left = `${rect.right + 8}px`
        dropdownMenu.style.top = `${rect.top}px`
        dropdownMenu.style.zIndex = '1050'
      })
    }
  })
}

// Auto-initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initNavbarNarrow)

// Re-initialize on dynamic content changes
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.classList?.contains('navbar-narrow') || 
                node.querySelector?.('.navbar-narrow')) {
              setTimeout(initNavbarNarrow, 100)
            }
          }
        })
      }
    })
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true
  })
}
